import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Model_VariableEnvironnementUser } from 'src/app/app.models';
import { EnvVarUserOfflineDao } from './envvaruser-offline.dao';
import { QueryParams_VariableEnvironnement, QueryParams_VariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';
 
const TB_ENVIRONMENT_VARIABLES_USER_NAME = "LOCAL_TB_ENVIRONMENT_VARIABLES_USER";

@Injectable()
export class EnvVarUserOfflineWebDao extends EnvVarUserOfflineDao {
    doSyncEnvironmentVariablesUserAction(_envVars: Model_VariableEnvironnementUser[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doClearEnvironmentVariablesUserAction();
            _envVars.forEach((envVar, index, vars) => vars[index].SYNCED = true);
            this.doInsertEnvironmentVariablesUserAction(_envVars).then(() => {
                resolve();
            }, err => reject(err));
        });
    }

    doClearEnvironmentVariablesUserAction() {
        return new Promise<void>((resolve, reject) => {
            localStorage.setItem(TB_ENVIRONMENT_VARIABLES_USER_NAME, "[]");
        });
    } 

    doGetEnvironmentVariablesUserAction(_queryParams?: QueryParams_VariableEnvironnementUser): Promise<Model_VariableEnvironnementUser[]> {
        if (_queryParams === undefined) 
            _queryParams = new QueryParams_VariableEnvironnement();

        return new Promise((resolve, reject) => {
            var datas: Model_VariableEnvironnementUser[] = [];
            const storageDatas = localStorage.getItem(TB_ENVIRONMENT_VARIABLES_USER_NAME);
            if (!!storageDatas && storageDatas != 'undefined' && storageDatas != 'null') {
                try {
                    datas = JSON.parse(storageDatas);
                } catch(e) { console.log(e) }
            }

            if (_queryParams.SYNCED !== undefined) {
                datas = datas.filter(d => d.SYNCED == _queryParams.SYNCED);
            }

            resolve(datas);
        });
    }

    doInsertEnvironmentVariablesUserAction(_envVars: Model_VariableEnvironnementUser[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetEnvironmentVariablesUserAction().then((_datasTable: Model_VariableEnvironnementUser[]) => {
                var newDatas = _datasTable.concat(_envVars);
                localStorage.setItem(TB_ENVIRONMENT_VARIABLES_USER_NAME, JSON.stringify(newDatas));
                resolve();
            }, err => reject(err));
        });
    }

    doSaveEnvironmentVariablesUserAction(_envVar: Model_VariableEnvironnementUser): Promise<Model_VariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            this.doGetEnvironmentVariablesUserAction().then((_datasTable: Model_VariableEnvironnementUser[]) => {
                var newDatas = _datasTable;
                var itemIndex = _datasTable.findIndex(i => i.NOM_VARIABLE == _envVar.NOM_VARIABLE);
                if (itemIndex !== -1) {
                    newDatas[itemIndex].SYNCED = _envVar.SYNCED;
                    newDatas[itemIndex].VALEUR_VARIABLE = _envVar.VALEUR_VARIABLE;
                    newDatas[itemIndex].DATE_MODIFICATION = moment().format();
                }
                localStorage.setItem(TB_ENVIRONMENT_VARIABLES_USER_NAME, JSON.stringify(newDatas));
                resolve(newDatas[itemIndex]);
            }, err => reject(err));
        });
    }

    doGetEnvironmentVariableUserAction(_id: string): Promise<Model_VariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            this.doGetEnvironmentVariablesUserAction().then((_datasTable: Model_VariableEnvironnementUser[]) => {
                const datasource = _datasTable.find(w => w.NOM_VARIABLE == _id);
                resolve(datasource);
            }, err => reject(err));
        });
    }
}
